import React from 'react';
import { Link } from 'rebass';
import Tippy from '@tippy.js/react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import 'tippy.js/dist/tippy.css'; // eslint-disable-line
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Img from 'gatsby-image'

const IconLink = styled(Link)`
  transition: color 0.5s;
  color: '#7c37ad';
  &:hover {
    color: '#ae66df';
  }
`;

const SocialLink = ({ fontAwesomeIcon, iconType, name, url, color, altImg}) => (
  <Tippy content={name ? name : ''} placement="bottom" trigger="mouseenter" arrow={false}>
    <IconLink
      href={url}
      target="_blank"
      color={color}
      rel="noreferrer"
      aria-label={name}
    >
    {fontAwesomeIcon ? <FontAwesomeIcon icon={[iconType, fontAwesomeIcon]} size='lg'/> : <div></div>}
    {altImg ? altImg && (<Img fluid={altImg.childImageSharp.fluid} style={{'padding': '1rem', 'margin': '2px'}}/>) : <div></div>}
    </IconLink>
  </Tippy>
);

SocialLink.propTypes = {
  fontAwesomeIcon: PropTypes.string,
  iconType: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
  color: PropTypes.string,
  altImg: PropTypes.object,
};

console.log('SOcial link ALT IMG', SocialLink.propTypes)

export default SocialLink;
